module.exports = __webpack_public_path__ + "img/63600.b23005bc.jpg";